import * as React from 'react';
import {
    FormControl,
    FormControlLabel,
    FormGroup,
    FormLabel,
    Grid,
    InputLabel,
    Radio, RadioGroup
} from "@material-ui/core";

interface IProps {

    initiateScriptChase?: any;
    completeScriptChase?: any;
    medicationList: any[];
    prescriber?: any;
    handleSetAddInsurancePlan?: any;
}

interface IState {
    createOrder: any,
    createOrderType: any,
    createOrderPaymentMethod: any,
}

class CheckoutFieldsSection extends React.Component<IProps, IState> {
    constructor(props: IProps) {
        super(props);

        this.state = {
            createOrder: true,
            createOrderPaymentMethod: 'cash',
            createOrderType: 'cash',
        };

        this.handleCreateOrder = this.handleCreateOrder.bind(this);
    }

    public render() {
        return (
            <Grid item xs={12}>
                <Grid
                    container
                    direction="column"
                    justify="center"
                    alignItems="center"
                    spacing={3}
                >
                    {this.props.completeScriptChase &&
                        this.props.medicationList.length > 0
                        && this.props.prescriber !== 'None'
                        && <Grid item xs>
                            <InputLabel style={{
                                color: "red",
                                fontSize: 18,
                                fontWeight: "bold",
                            }}>Order Section</InputLabel>
                        </Grid>}

                    {this.props.completeScriptChase &&
                        this.props.medicationList.length > 0
                        && this.props.prescriber !== 'None'
                        && <Grid item xs>
                            <FormControl component="fieldset">
                                <FormLabel component="legend">Order Creation Types</FormLabel>
                                <FormGroup style={{width: 225}}>
                                    <RadioGroup aria-label="createOrderType"
                                                name="createOrderType"
                                                value={this.state.createOrderType}
                                                onChange={this.handleCreateOrder}
                                                style={{width: 225}}>
                                        <FormControlLabel value="cash" control={
                                            <Radio/>
                                        } label="Cash Order (no Insurance, not Prime)"/>
                                        <FormControlLabel value="singleInsurance" control={
                                            <Radio/>
                                        } label="Single Insurance Order"/>
                                        <FormControlLabel value="multiInsurance" control={
                                            <Radio/>
                                        } label="Multi-Insurance Order"/>
                                    </RadioGroup>
                                </FormGroup>
                            </FormControl>
                        </Grid>
                    }

                    {this.props.completeScriptChase &&
                        this.props.medicationList.length > 0
                        && this.props.prescriber !== 'None'
                        && <Grid item xs>
                            <FormControl component="fieldset">
                                <FormLabel component="legend">Order Payment Methods</FormLabel>
                                <FormGroup style={{width: 225}}>
                                    <RadioGroup aria-label="createOrderPaymentMethod"
                                                name="createOrderPaymentMethod"
                                                value={this.state.createOrderPaymentMethod}
                                                onChange={this.handleCreateOrder}
                                                style={{width: 225}}>
                                        <FormControlLabel value="cash" control={
                                            <Radio/>
                                        } label="Pay with Credit Card"/>
                                        <FormControlLabel value="giftCard" control={
                                            <Radio/>
                                        } label="Pay with Gift Card"/>
                                        <FormControlLabel value="hsaCard" control={
                                            <Radio/>
                                        } label="Pay with HSA Card"/>
                                    </RadioGroup>
                                </FormGroup>
                            </FormControl>
                        </Grid>
                    }

                </Grid>
            </Grid>
        );
    }

    public setCashOrder() {
        this.setCreateOrderType('cash')
    }

    public setSingleInsuranceOrder() {
        this.setCreateOrderType('singleInsurance')
    }

    public setMultiInsuranceOrder() {
        this.setCreateOrderType('multiInsurance')
    }

    public handleCreateOrder(event: React.ChangeEvent<HTMLInputElement>) {
        const createOrderType = event.target.value as string
        const createOrderPaymentMethod = event.target.value as string
        this.setState({createOrder: true})
        this.setState({createOrderType})
        this.setState({createOrderPaymentMethod})

        if ((createOrderType === "cash") || (createOrderType === "primeRx")) {
            this.props.handleSetAddInsurancePlan(false, false)
        } else if (createOrderType === "singleInsurance") {
            this.props.handleSetAddInsurancePlan(true, false)
        } else {
            this.props.handleSetAddInsurancePlan(true, true)
        }
    }

    public getState() {
        return this.state;
    }

    private setCreateOrderType(type: string) {
        this.setState( {createOrderType: type})
    }
}

export default CheckoutFieldsSection
